import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { DropdownAutocomplete } from 'legacy/lut/components/widgets/public/partner360/editors/DropdownAutocomplete'
import { FC, useCallback } from 'react'

import { useGetFormDataField } from 'cng-common/features/form'
import { Input } from 'core-components/library/inputs'

import { HP_CONTACT_REQUEST_EDITOR_FORM } from '../../config'
import { getCleanEmail } from '../../lib'

import styles from './EmailField.module.scss'

interface IEmailFieldProps {
  isRequestAccess?: boolean
  requestAction: string
  email: string
  userCrud: any
  isTicketStatusInProgress: boolean
  shouldKeepCurrentUser?: boolean
}

export const EmailField: FC<IEmailFieldProps> = ({
  isRequestAccess,
  requestAction,
  email,
  userCrud,
  isTicketStatusInProgress,
  shouldKeepCurrentUser,
}) => {
  const [emailValue = '', onChangeEmailValue] = useGetFormDataField<string>(
    HP_CONTACT_REQUEST_EDITOR_FORM,
    'Email'
  )

  const [, onChangeFirstName] = useGetFormDataField<string>(
    HP_CONTACT_REQUEST_EDITOR_FORM,
    'FirstName'
  )

  const [, onChangeLastName] = useGetFormDataField<string>(
    HP_CONTACT_REQUEST_EDITOR_FORM,
    'LastName'
  )

  const changeEmail = useCallback(
    (newValue: string) => {
      const cleanEmail = getCleanEmail(newValue)
      onChangeEmailValue(cleanEmail)
    },
    [onChangeEmailValue]
  )

  const changeEmailItem = useCallback(
    (emailItem: IObjectAny) => {
      onChangeEmailValue(emailItem['Id'])
      onChangeFirstName(emailItem['FirstName'])
      onChangeLastName(emailItem['LastName'])
    },
    [onChangeEmailValue, onChangeFirstName, onChangeLastName]
  )

  const handleValidate = useCallback(
    async (value: string) => ValidationHelper.checkFullEmail(value, ['@hp.com']),
    []
  )

  if (!isRequestAccess && requestAction === 'Add') {
    return (
      <DropdownAutocomplete
        label={'Email *'}
        fieldsToSearch={['UserAccountName']}
        classes={{ popPaper: styles.rolePaper }}
        calculateCaption={(item: IObjectAny) => `${item.FirstName} ${item.LastName} <${item.Id}>`}
        value={emailValue}
        source={userCrud}
        validateName="Id"
        mode="combobox"
        checkFn={handleValidate}
        onChange={changeEmail}
        onItemChange={changeEmailItem}
        disabled={
          requestAction !== 'Add' ||
          isRequestAccess ||
          isTicketStatusInProgress ||
          shouldKeepCurrentUser
        }
        translation="jbp-hpcontactinfo-email-required"
      />
    )
  }

  return <Input type="text" label={'Email *'} value={email || ''} disabled={true} />
}
